"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 146 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    className: "logo_svg__text",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.431 4.977v8.369h5.206v1.765H.515V4.977h1.916zm15.194 10.134h-7.58V4.977h7.58v1.85h-5.68v2.326h5.477v1.782h-5.478v2.292h5.681v1.884zm8.207.051h-1.967L19.66 4.977h2.137l3.052 7.894 3.07-7.894h2.136l-4.223 10.185zm14.024-.051h-7.58V4.977h7.58v1.85h-5.68v2.326h5.477v1.782h-5.478v2.292h5.681v1.884zm4.477-10.134v8.369h5.206v1.765h-7.123V4.977h1.917zm43.328 1.731h-3.205V4.977h8.326v1.731h-3.205v8.403h-1.916V6.708zm16.347 8.403h-2.273l-2.95-3.395h-1.831v3.395h-1.917V4.96c1.611 0 3.205.017 4.816.017 2.391.017 3.646 1.613 3.646 3.361 0 1.392-.644 2.801-2.561 3.192l3.07 3.463v.118zM96.937 6.76v3.243h2.9c1.22 0 1.729-.815 1.729-1.63s-.543-1.63-1.73-1.63h-2.9v.017zm16.126 6.45h-5.291l-.865 1.918h-2.068l4.544-10.134h2.069l4.544 10.134h-2.085l-.848-1.918zm-2.645-6.11-1.883 4.312h3.765L110.418 7.1zm11.361 8.062h-1.984L115.59 4.977h2.136l3.053 7.894 3.069-7.894h2.136l-4.205 10.185zm14.024-.051h-7.58V4.977h7.58v1.85h-5.681v2.326h5.477v1.782h-5.477v2.292h5.681v1.884zm4.476-10.134v8.369h5.206v1.765h-7.122V4.977h1.916z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.947 10c0 5.522-4.474 10-9.99 10-5.515 0-9.989-4.478-9.989-10s4.473-10 9.99-10c5.515 0 9.989 4.478 9.989 10z",
    fill: "url(#logo_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.957 4.003a5.352 5.352 0 0 0-5.32 5.908.557.557 0 0 0 .53.462h9.576c.256 0 .493-.21.53-.462 0 0 .028-.21.028-.554a5.342 5.342 0 0 0-5.344-5.354z",
    fill: "#FCEE21"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.591 11.77c0 .28-.251.513-.558.513H59.836c-.307 0-.559-.233-.559-.512 0-.28.252-.513.559-.513h14.197c.307 0 .558.233.558.513zm-2.094 1.958c0 .284-.252.513-.559.513H61.93c-.307 0-.558-.229-.558-.513 0-.284.251-.513.558-.513h10.008c.307 0 .559.229.559.513zm-2.514 1.957c0 .284-.251.513-.559.513h-4.98c-.307 0-.559-.229-.559-.513 0-.284.252-.513.559-.513h4.98c.308 0 .559.229.559.513z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__a",
    x1: 56.97,
    y1: 19.998,
    x2: 56.97,
    y2: 0.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FA9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D7FF"
  }))));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgLogo);
var _default = exports["default"] = Memo;